import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'

/**
 * Gates the web shopping assistant (header search entry point + the
 * layout-mounted host).
 *
 * Backed by the `experiment.shoppingAssistantWeb` CloudBees experiment rather
 * than a runtime feature flag, so the rollout can be scoped to a QA audience
 * via targeting. Returns true only for the `withAssistant` variation.
 */
export function useIsShoppingAssistantWebEnabled(): boolean {
  return useExperiments()['experiment.shoppingAssistantWeb'] === 'withAssistant'
}
